import React, { Component } from "react";
import { ErrorContainer } from "@eres/forms";
import Popup from "@my-dld/components/Popup/Popup";
import Strings from "@my-dld/assets/strings";
import { Comment, PrvSellLookUp, PvtSellLookUp, PvtSellRequest } from "../../../apis/privatesell/enitites";
import PickerInput from "@my-dld/components/Form/PickerInput";
import TextInputField from "@eres/forms-web/TextInputField";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import { defaultErrorManager } from "@eres/forms/errormanager";
import { populatePrvtSellLookup } from "../../../apis/privatesell/services";
import { checkNonEmpty } from "@my-dld/components/Form/FormField";
import { LocaleUtil } from "@eres/core";
import { privateSellApi } from "../../../apis/privatesell";
import { hideLoading, showLoading, showMessage } from "@my-dld/utils/UIUtils";
import { trackEventWithData } from "@my-dld/utils/Analytics";
import { JQModal } from "@my-dld/components/Popup/Utils";
import MessageActionButtonPopup from "@my-dld/components/Popup/MessageActionButtonPopup";

interface Props {
	transaction: PvtSellRequest;
	onReject: () => void;
}

interface State {
	errorContainer: ErrorContainer;
	CommentReasons: PvtSellLookUp[];
	CommentReason?: PvtSellLookUp;
	Description?: string;
	isRejectSuccess: boolean;
}

export default class RejectRequest extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			errorContainer: {},
			CommentReasons: [],
			isRejectSuccess: false,
		};
	}

	componentDidMount(): void {
		populatePrvtSellLookup( PrvSellLookUp.COMMENT_REASON, this );
	}

	render() {
		const { transaction } = this.props;
		const { errorContainer, CommentReasons, isRejectSuccess } = this.state;
		const kvProp = { inputClassName: "form-control", holder: this, containerClassName: "col-md-6 form-group" };
		let disclaimer = Strings.booking_ref_number + " : " + transaction.bookingRequestInfo.referenceNumber;
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			errorManager: defaultErrorManager,
		};
		return <><Popup
			modalSubContainer={ "modal-dialog modal-dialog-centered modal-lg" } id={ "reject_comment_popup" }
			modalBodyContainer="" title={ Strings.booking_request } showIcon={ false }>
			<div className="modal-body">
				{ disclaimer }
				<hr/>
				<div className="row">
					<div className="col-md-12">
						<PickerInput
							{ ...kvProp }
							label={ Strings.reason_for_rejection }
							id={ "CommentReason" }
							items={ CommentReasons }
							containerClassName="form-group field-style select-control"
							required={ true }
							error={ errorContainer.CommentReason }
							toIdentifier={ ( item: PvtSellLookUp ) => item.identity + "" }
							onValueChange={ ( comment?: PvtSellLookUp ) => {
								this.setState( { CommentReason: comment } );
							} }
						/>
					</div>
					<div className={ "col-md-12" }>
						<TextInputField
							{ ...filedProps }
							id={ "Description" }
							required={ true }
							containerClassName="form-group"
							customInput={ <textarea rows={ 4 } maxLength={ 1000 }/> }
							label={ Strings.rejection_reason }
						/>
					</div>
				</div>
			</div>
			<div className="modal-footer justify-content-center">
				<button
					type="button" className="btn btn-grey"
					data-bs-dismiss="modal">{ Strings.cancel }</button>
				<button type="button" className="btn btn_1" onClick={ this.isValid }>{ Strings.submit }</button>
			</div>
		</Popup>
			{
				isRejectSuccess &&
				<MessageActionButtonPopup message={ Strings.req_sell_rejected } onAction={ this.props.onReject } onCancel={ this.props.onReject }/>
			}
		</>;
	}

	isValid = () => {
		let errorViews: ErrorContainer = {};
		let isValid = true;
		isValid = checkNonEmpty( this.state, "CommentReason", errorViews ) && isValid;
		isValid = checkNonEmpty( this.state, "Description", errorViews ) && isValid;
		this.setState( { errorContainer: errorViews }, () => {
			if ( isValid ) {
				//  this.props.onAccept(this.state.CommentReason!, this.state.Description);
				showLoading();
				let { transaction } = this.props;
				let bookingReq = transaction.bookingRequestInfo!.bookingRequest;
				if ( bookingReq === undefined || bookingReq === null ) {
					bookingReq = {};
				}
				let comment: Comment = {};
				comment.commentId = 0;
				let c = this.state.CommentReason;
				let commentText = "";
				if ( c ) commentText = LocaleUtil.getLocalValue( c );
				commentText = commentText + " - " + this.state.Description;
				comment.comment = commentText;
				comment.createdDate = new Date().asServerString();
				bookingReq.commentList = [ comment ];
				transaction.bookingRequestInfo!.bookingRequest = bookingReq;
				let param = {
					bookingRef: transaction.bookingRequestInfo!.referenceNumber + "",
					reason: commentText,
				};
				const apiHandler = () => {
					hideLoading();
					trackEventWithData( "PrivateSell", "BuyerRequestReject", param );
					this.setState( { isRejectSuccess: true }, JQModal( "reject_comment_popup" ).hide );
					// showMessage(Strings.req_sell_rejected);
					// JQModal("reject_comment_popup").hide(onReject);
				};
				const exHandler = ( reason: any ) => {
					hideLoading();
					if ( reason && reason.type && reason.type === "ValidationError" ) {
						showMessage( Strings.system_error + "\n" + reason.message );
						trackEventWithData( "PrivateSell", "BuyerRequestRejectFailed",
							{ ...param, error: Strings.system_error + "-" + reason.message } );
					} else {
						showMessage( reason.toString() );
						trackEventWithData( "PrivateSell", "BuyerRequestRejectFailed",
							{ ...param, error: reason.toString() } );
					}
				};
				privateSellApi.rejectBookingRequest( transaction ).then( apiHandler ).catch( exHandler );
			}
		} );
	};
}
